import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useCallback, useEffect } from "react"
import { useSelector } from "react-redux"
import { useBlocker } from "react-router-dom"

import Column from "../../../../common/components/Column"
import { selectHasUnsavedChanges } from "../reducer"

export default function UnsavedChangesPreventLeaveDialog({ workflowDeleted }) {
  const workflowHasChanged = useSelector(selectHasUnsavedChanges)

  function handleClosed() {
    navigationBlocker?.reset()
  }

  const shouldBlockNavigation = useCallback(
    ({ currentLocation, nextLocation }) => {
      return (
        workflowHasChanged &&
        !workflowDeleted &&
        currentLocation.pathname !== nextLocation.pathname
      )
    },
    [workflowHasChanged, workflowDeleted]
  )

  useEffect(
    () => {
      if (workflowDeleted) {
        // I think the callback above blocks the navigator even if workflow is deleted
        // and workflowDeleted flag is set after it already blocks
        navigationBlocker?.proceed()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [workflowDeleted]
  )

  const navigationBlocker = useBlocker(shouldBlockNavigation)

  return (
    <Dialog
      open={navigationBlocker.state === "blocked"}
      onClose={handleClosed}
      maxWidth="xs"
    >
      <DialogContent>
        <Column sx={{ alignItems: "center", textAlign: "center" }}>
          <Typography variant="h5" sx={{ mt: 2 }}>
            Are you sure you want to leave?
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            Any unsaved changes will be lost.
          </Typography>
        </Column>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigationBlocker.proceed()}
        >
          Yes I'm sure
        </Button>
        <Button variant="contained" color="primary" onClick={handleClosed}>
          Stay
        </Button>
      </DialogActions>
    </Dialog>
  )
}
